"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[717],{

/***/ 716:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _data_items_tabs_data__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9317);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lib_client_aleo__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6833);
/* harmony import */ var _demox_labs_aleo_wallet_adapter_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9023);
/* harmony import */ var react_alert__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(406);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);











function loadUserWalletProofs(publicKey, requestRecords, alert, setCategory, loading, setLoading, setData) {
    return _loadUserWalletProofs.apply(this, arguments);
}
function _loadUserWalletProofs() {
    _loadUserWalletProofs = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(publicKey, requestRecords, alert, setCategory, loading, setLoading, setData) {
        var leos, e, ref, err_str;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (loading) return [
                        2
                    ];
                    setLoading(true);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0,lib_client_aleo__WEBPACK_IMPORTED_MODULE_4__/* .get_user_proofs */ .Yl)(publicKey, requestRecords)
                    ];
                case 2:
                    leos = _state.sent();
                    console.log("leos", leos);
                    setData(leos.sort(function(a, b) {
                        return Number(b.height) - Number(a.height);
                    }));
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    err_str = (e === null || e === void 0 ? void 0 : (ref = e.error) === null || ref === void 0 ? void 0 : ref.message) || (e === null || e === void 0 ? void 0 : e.message) || e + "";
                    alert.error(err_str);
                    setCategory(1);
                    return [
                        3,
                        4
                    ];
                case 4:
                    setLoading(false);
                    return [
                        2
                    ];
            }
        });
    });
    return _loadUserWalletProofs.apply(this, arguments);
}
var Activity_tab = function(param) {
    var setCategory = param.setCategory;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), data = ref[0], setData = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,_demox_labs_aleo_wallet_adapter_react__WEBPACK_IMPORTED_MODULE_5__/* .useWallet */ .Os)(), publicKey = ref2.publicKey, requestRecords = ref2.requestRecords, requestTransaction = ref2.requestTransaction;
    var alert = (0,react_alert__WEBPACK_IMPORTED_MODULE_6__/* .useAlert */ .VY)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        loadUserWalletProofs(publicKey, requestRecords, alert, setCategory, loading, setLoading, setData);
    }, [
        publicKey
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "tab-pane fade",
            id: "activity",
            role: "tabpanel",
            "aria-labelledby": "activity-tab",
            children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex justify-center items-center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-jacarta-500"
                })
            }) : data.length === 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex justify-center items-center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "text-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "text-2xl font-semibold mb-2",
                            children: "No proof recieved yet"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "text-sm text-jacarta-500 dark:text-jacarta-400 normal-case ",
                            children: "You will find here proofs sent by user of ownership of NFTs and collections as well as holdership of collection items."
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                role: "table",
                className: "scrollbar-custom dark:bg-jacarta-700 dark:border-jacarta-600 border-jacarta-100 max-h-72 w-full overflow-y-auto rounded-lg rounded-tl-none border bg-white text-sm dark:text-white",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "dark:bg-jacarta-600 bg-light-base sticky top-0 flex",
                        role: "row",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "w-[25%] py-2 px-4",
                                role: "columnheader",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "text-jacarta-700 dark:text-jacarta-100 w-full overflow-hidden text-ellipsis",
                                    children: "Type"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "w-[25%] py-2 px-4",
                                role: "columnheader",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "text-jacarta-700 dark:text-jacarta-100 w-full overflow-hidden text-ellipsis",
                                    children: "Object"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "w-[25%] py-2 px-4",
                                role: "columnheader",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "text-jacarta-700 dark:text-jacarta-100 w-full overflow-hidden text-ellipsis",
                                    children: "Prover"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "w-[25%] py-2 px-4",
                                role: "columnheader",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "text-jacarta-700 dark:text-jacarta-100 w-full overflow-hidden text-ellipsis",
                                    children: "Block"
                                })
                            })
                        ]
                    }),
                    data.map(function(item) {
                        console.log("item", item);
                        var id = item.id, prover = item.prover, height = item.height, object_type = item.object_type, proof_type = item.proof_type, object_hex_id = item.object_hex_id;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex",
                            role: "row",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "truncate dark:border-jacarta-600 border-jacarta-100 flex w-[25%] items-center border-t py-4 px-4",
                                    role: "cell",
                                    style: {
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textTransform: "capitalize"
                                    },
                                    children: [
                                        object_type === "token" && proof_type === "ownership" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            viewBox: "0 0 24 24",
                                            width: "24",
                                            height: "24",
                                            className: "fill-jacarta-700 mr-2 h-4 w-4 group-hover:fill-white dark:fill-white",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    style: {
                                                        transform: " scale(0.05)"
                                                    },
                                                    id: "Page-1",
                                                    stroke: "none",
                                                    "stroke-width": "1",
                                                    fill: "none",
                                                    "fill-rule": "evenodd",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                                                        id: "icon",
                                                        fill: "#000000",
                                                        transform: "translate(42.666667, 85.333333)",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                            d: "M426.666667,1.42108547e-14 L426.666667,341.333333 L3.55271368e-14,341.333333 L3.55271368e-14,1.42108547e-14 L426.666667,1.42108547e-14 Z M384,42.6666667 L42.6666667,42.6666667 L42.6666667,298.666667 L384,298.666667 L384,42.6666667 Z M341.333333,213.333333 L341.333333,245.333333 L234.666667,245.333333 L234.666667,213.333333 L341.333333,213.333333 Z M341.333333,149.333333 L341.333333,181.333333 L234.666667,181.333333 L234.666667,149.333333 L341.333333,149.333333 Z M192,85.3333333 L192,170.666667 L85.3333333,170.666667 L85.3333333,85.3333333 L192,85.3333333 Z M341.333333,85.3333333 L341.333333,117.333333 L234.666667,117.333333 L234.666667,85.3333333 L341.333333,85.3333333 Z",
                                                            id: "Combined-Shape"
                                                        })
                                                    })
                                                }),
                                                "         "
                                            ]
                                        }),
                                        object_type === "collection" && proof_type === "ownership" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            viewBox: "0 0 24 24",
                                            width: "24",
                                            height: "24",
                                            className: "fill-jacarta-700 mr-2 h-4 w-4 group-hover:fill-white dark:fill-white",
                                            style: {
                                                transform: "translate(1px, 2px)"
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("use", {
                                                xlinkHref: "/icons.svg#icon-listing"
                                            })
                                        }),
                                        object_type === "collection" && proof_type === "holdership" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            viewBox: "0 0 24 24",
                                            width: "24",
                                            height: "24",
                                            className: "fill-jacarta-700 mr-2 h-4 w-4 group-hover:fill-white dark:fill-white",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                style: {
                                                    transform: " scale(0.2)"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                                        points: "91,45 83,45 83,73 73,73 73,119 61,119 61,73 51,73 51,45 43,45 43,81 53,81 53,127 81,127 81,81 91,81 "
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                        d: "M53,15c0,7.7,6.3,14,14,14s14-6.3,14-14S74.7,1,67,1S53,7.3,53,15z M73,15c0,3.3-2.7,6-6,6s-6-2.7-6-6s2.7-6,6-6 S73,11.7,73,15z"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                        d: "M19,25c0,7.7,6.3,14,14,14s14-6.3,14-14s-6.3-14-14-14S19,17.3,19,25z M39,25c0,3.3-2.7,6-6,6s-6-2.7-6-6s2.7-6,6-6 S39,21.7,39,25z"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                                        points: "113,83 103,83 103,119 87,119 87,127 111,127 111,91 121,91 121,51 113,51 "
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                        d: "M87,25c0,7.7,6.3,14,14,14s14-6.3,14-14s-6.3-14-14-14S87,17.3,87,25z M101,19c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6 S97.7,19,101,19z"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                                        points: "31,83 21,83 21,51 13,51 13,91 23,91 23,127 47,127 47,119 31,119 "
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                            children: object_type + " " + proof_type
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "normal-case truncate dark:border-jacarta-600 border-jacarta-100 flex w-[25%] items-center whitespace-nowrap border-t py-4 px-4",
                                    role: "cell",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "text-green text-sm font-medium tracking-tight",
                                        style: {
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden"
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                            href: "/".concat(object_type, "/").concat(object_hex_id),
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                className: "normal-case hover:underline",
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                children: object_hex_id
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "normal-case truncate dark:border-jacarta-600 border-jacarta-100 flex w-[25%] items-center border-t py-4 px-4",
                                    role: "cell",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                        href: "/user/".concat(prover),
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            className: "text-accent normal-case hover:underline",
                                            style: {
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden"
                                            },
                                            children: prover
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "normal-case truncate dark:border-jacarta-600 border-jacarta-100 flex w-[25%] items-center border-t py-4 px-4",
                                    role: "cell",
                                    style: {
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden"
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                        href: "https://explorer.hamp.app/block?h=".concat(height),
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            className: "text-accent hover:underline",
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            children: height.toString()
                                        })
                                    })
                                })
                            ]
                        }, object_hex_id + height.toString());
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Activity_tab);


/***/ }),

/***/ 1362:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony exports collection_data, collection_item_data, collection_activity_item_data, collectionCategoryData */
var collection_data = [
    {
        id: 1,
        title: "NFT Funny Cat",
        image: "/images/avatars/avatar_1.jpg",
        icon: true,
        amount: "7,080.95",
        postTime: "2022-07-20",
        postDate: "Last 24 Hours"
    },
    {
        id: 2,
        title: "Cryptopank",
        image: "/images/avatars/avatar_2.jpg",
        icon: true,
        amount: "6,548,133",
        postTime: "2022-07-10",
        postDate: "Last 24 Hours"
    },
    {
        id: 3,
        title: "Prince Ape Planet",
        image: "/images/avatars/avatar_3.jpg",
        icon: false,
        amount: "4,823,927",
        postTime: "2022-07-08",
        postDate: "Last 24 Hours"
    },
    {
        id: 4,
        title: "Hey Mrsmeseks",
        image: "/images/avatars/avatar_4.jpg",
        icon: true,
        amount: "3,186",
        postTime: "2022-07-01",
        postDate: "Last 24 Hours"
    },
    {
        id: 5,
        title: "Bored Bunny",
        image: "/images/avatars/avatar_5.jpg",
        icon: false,
        amount: "3,027",
        postTime: "2022-07-05",
        postDate: "Last 24 Hours"
    },
    {
        id: 6,
        title: "Wow Frens",
        image: "/images/avatars/avatar_6.jpg",
        icon: false,
        amount: "2,586",
        postTime: "2022-07-08",
        postDate: "Last 7 days"
    },
    {
        id: 7,
        title: "Origin Morish",
        image: "/images/avatars/avatar_7.jpg",
        icon: true,
        amount: "2,347.85",
        postTime: "2022-07-20",
        postDate: "Last 7 days"
    },
    {
        id: 8,
        title: "Superdo",
        image: "/images/avatars/avatar_8.jpg",
        icon: true,
        amount: "2,115.71",
        postTime: "2022-07-10",
        postDate: "Last 7 days"
    },
    {
        id: 9,
        title: "NFT stars",
        image: "/images/avatars/avatar_9.jpg",
        icon: false,
        amount: "2,027",
        postTime: "2022-07-12",
        postDate: "Last 7 days"
    },
    {
        id: 10,
        title: "Asumitsu",
        image: "/images/avatars/avatar_10.jpg",
        icon: true,
        amount: "1,989.70",
        postTime: "2022-07-15",
        postDate: "Last 7 days"
    },
    {
        id: 11,
        title: "Pank Skull",
        image: "/images/avatars/avatar_11.jpg",
        icon: false,
        amount: "1,726.70",
        postTime: "2022-07-16",
        postDate: "Last 7 days"
    },
    {
        id: 12,
        title: "Lazy Panda",
        image: "/images/avatars/avatar_12.jpg",
        icon: false,
        amount: "1,589.03",
        postTime: "2022-07-14",
        postDate: "Last 7 days"
    },
    {
        id: 13,
        title: "Arcahorizons",
        image: "/images/avatars/avatar_13.jpg",
        icon: true,
        amount: "1,157",
        postTime: "2022-07-20",
        postDate: "Last 24 Hours"
    },
    {
        id: 14,
        title: "Sussygirl",
        image: "/images/avatars/avatar_14.jpg",
        icon: false,
        amount: "1,030",
        postTime: "2022-06-20",
        postDate: "Last 24 Hours"
    },
    {
        id: 15,
        title: "Smilebin",
        image: "/images/avatars/avatar_15.jpg",
        icon: true,
        amount: "999.51",
        postTime: "2022-07-20",
        postDate: "Last 7 days"
    },
    {
        id: 16,
        title: "Pankysmoke",
        image: "/images/avatars/avatar_16.jpg",
        icon: false,
        amount: "875.65",
        postTime: "2022-07-20",
        postDate: "Last 7 days"
    }, 
];
var collection_item_data = [
    {
        id: "avatar_1",
        title: "NFT Funny Cat",
        image: "/images/avatars/avatar_1.jpg",
        icon: true,
        creator: "051_Hart",
        text: "Unique, fully 3D and built to unite the design multiverse. Designed and styled by Digimental.",
        amount: "7,080.95",
        details: [
            {
                id: "07.2K",
                detailsNumber: "7.2K",
                detailsText: "Items"
            },
            {
                id: "15.3K",
                detailsNumber: "5.3K",
                detailsText: "Owners"
            },
            {
                id: "22.55",
                detailsNumber: "2.55",
                detailsText: "Floor Price"
            },
            {
                id: "317.2K",
                detailsNumber: "17.2K",
                detailsText: "Volume Traded"
            }, 
        ]
    },
    {
        id: "avatar_2",
        title: "Cryptopank",
        image: "/images/avatars/avatar_2.jpg",
        icon: true,
        creator: "Wow Frens",
        text: "Unique, fully 3D and built to unite the design multiverse. Designed and styled by Digimental.",
        details: [
            {
                id: "07.2K",
                detailsNumber: "7.2K",
                detailsText: "Items"
            },
            {
                id: "15.3K",
                detailsNumber: "5.3K",
                detailsText: "Owners"
            },
            {
                id: "22.55",
                detailsNumber: "2.55",
                detailsText: "Floor Price"
            },
            {
                id: "317.2K",
                detailsNumber: "17.2K",
                detailsText: "Volume Traded"
            }, 
        ],
        amount: "6,548,133"
    },
    {
        id: "avatar_3",
        title: "Prince Ape Planet",
        image: "/images/avatars/avatar_3.jpg",
        icon: false,
        creator: "Origin Morish",
        text: "Unique, fully 3D and built to unite the design multiverse. Designed and styled by Digimental.",
        details: [
            {
                id: "07.2K",
                detailsNumber: "7.2K",
                detailsText: "Items"
            },
            {
                id: "15.3K",
                detailsNumber: "5.3K",
                detailsText: "Owners"
            },
            {
                id: "22.55",
                detailsNumber: "2.55",
                detailsText: "Floor Price"
            },
            {
                id: "317.2K",
                detailsNumber: "17.2K",
                detailsText: "Volume Traded"
            }, 
        ],
        amount: "NFT stars"
    },
    {
        id: "avatar_4",
        title: "Hey Mrsmeseks",
        image: "/images/avatars/avatar_4.jpg",
        icon: true,
        creator: "Lazy Panda",
        text: "Unique, fully 3D and built to unite the design multiverse. Designed and styled by Digimental.",
        details: [
            {
                id: "07.2K",
                detailsNumber: "7.2K",
                detailsText: "Items"
            },
            {
                id: "15.3K",
                detailsNumber: "5.3K",
                detailsText: "Owners"
            },
            {
                id: "22.55",
                detailsNumber: "2.55",
                detailsText: "Floor Price"
            },
            {
                id: "317.2K",
                detailsNumber: "17.2K",
                detailsText: "Volume Traded"
            }, 
        ],
        amount: "3,186"
    },
    {
        id: "avatar_5",
        title: "Bored Bunny",
        image: "/images/avatars/avatar_5.jpg",
        icon: false,
        creator: "Crytopank",
        text: "Unique, fully 3D and built to unite the design multiverse. Designed and styled by Digimental.",
        details: [
            {
                id: "07.2K",
                detailsNumber: "7.2K",
                detailsText: "Items"
            },
            {
                id: "15.3K",
                detailsNumber: "5.3K",
                detailsText: "Owners"
            },
            {
                id: "22.55",
                detailsNumber: "2.55",
                detailsText: "Floor Price"
            },
            {
                id: "317.2K",
                detailsNumber: "17.2K",
                detailsText: "Volume Traded"
            }, 
        ],
        amount: "3,027"
    },
    {
        id: "avatar_6",
        title: "Wow Frens",
        image: "/images/avatars/avatar_6.jpg",
        icon: false,
        creator: "Hey Mrsmeseks",
        text: "Unique, fully 3D and built to unite the design multiverse. Designed and styled by Digimental.",
        details: [
            {
                id: "07.2K",
                detailsNumber: "7.2K",
                detailsText: "Items"
            },
            {
                id: "15.3K",
                detailsNumber: "5.3K",
                detailsText: "Owners"
            },
            {
                id: "22.55",
                detailsNumber: "2.55",
                detailsText: "Floor Price"
            },
            {
                id: "317.2K",
                detailsNumber: "17.2K",
                detailsText: "Volume Traded"
            }, 
        ],
        amount: "2,586"
    },
    {
        id: "avatar_7",
        title: "Origin Morish",
        image: "/images/avatars/avatar_7.jpg",
        icon: true,
        creator: "alyxbow",
        text: "Unique, fully 3D and built to unite the design multiverse. Designed and styled by Digimental.",
        details: [
            {
                id: "07.2K",
                detailsNumber: "7.2K",
                detailsText: "Items"
            },
            {
                id: "15.3K",
                detailsNumber: "5.3K",
                detailsText: "Owners"
            },
            {
                id: "22.55",
                detailsNumber: "2.55",
                detailsText: "Floor Price"
            },
            {
                id: "317.2K",
                detailsNumber: "17.2K",
                detailsText: "Volume Traded"
            }, 
        ],
        amount: "2,347.85"
    },
    {
        id: " avatar_8",
        title: "Superdo",
        image: "/images/avatars/avatar_8.jpg",
        icon: true,
        creator: "Wow Frens",
        text: "Unique, fully 3D and built to unite the design multiverse. Designed and styled by Digimental.",
        details: [
            {
                id: "07.2K",
                detailsNumber: "7.2K",
                detailsText: "Items"
            },
            {
                id: "15.3K",
                detailsNumber: "5.3K",
                detailsText: "Owners"
            },
            {
                id: "22.55",
                detailsNumber: "2.55",
                detailsText: "Floor Price"
            },
            {
                id: "317.2K",
                detailsNumber: "17.2K",
                detailsText: "Volume Traded"
            }, 
        ],
        amount: "2,115.71"
    },
    {
        id: "avatar_9",
        title: "NFT stars",
        image: "/images/avatars/avatar_9.jpg",
        icon: false,
        creator: "NFT stars",
        text: "Unique, fully 3D and built to unite the design multiverse. Designed and styled by Digimental.",
        details: [
            {
                id: "07.2K",
                detailsNumber: "7.2K",
                detailsText: "Items"
            },
            {
                id: "15.3K",
                detailsNumber: "5.3K",
                detailsText: "Owners"
            },
            {
                id: "22.55",
                detailsNumber: "2.55",
                detailsText: "Floor Price"
            },
            {
                id: "317.2K",
                detailsNumber: "17.2K",
                detailsText: "Volume Traded"
            }, 
        ],
        amount: "2,027"
    },
    {
        id: "avatar_10",
        title: "Asumitsu",
        image: "/images/avatars/avatar_10.jpg",
        icon: true,
        creator: "Origin Morish",
        text: "Unique, fully 3D and built to unite the design multiverse. Designed and styled by Digimental.",
        details: [
            {
                id: "07.2K",
                detailsNumber: "7.2K",
                detailsText: "Items"
            },
            {
                id: "15.3K",
                detailsNumber: "5.3K",
                detailsText: "Owners"
            },
            {
                id: "22.55",
                detailsNumber: "2.55",
                detailsText: "Floor Price"
            },
            {
                id: "317.2K",
                detailsNumber: "17.2K",
                detailsText: "Volume Traded"
            }, 
        ],
        amount: "1,989.70"
    },
    {
        id: "avatar_11",
        title: "Pank Skull",
        image: "/images/avatars/avatar_11.jpg",
        icon: false,
        creator: "Lazy Panda",
        text: "Unique, fully 3D and built to unite the design multiverse. Designed and styled by Digimental.",
        details: [
            {
                id: "07.2K",
                detailsNumber: "7.2K",
                detailsText: "Items"
            },
            {
                id: "15.3K",
                detailsNumber: "5.3K",
                detailsText: "Owners"
            },
            {
                id: "22.55",
                detailsNumber: "2.55",
                detailsText: "Floor Price"
            },
            {
                id: "317.2K",
                detailsNumber: "17.2K",
                detailsText: "Volume Traded"
            }, 
        ],
        amount: "1,726.70"
    },
    {
        id: "avatar_12",
        title: "Lazy Panda",
        image: "/images/avatars/avatar_12.jpg",
        icon: false,
        creator: "051_Hart",
        text: "Unique, fully 3D and built to unite the design multiverse. Designed and styled by Digimental.",
        details: [
            {
                id: "07.2K",
                detailsNumber: "7.2K",
                detailsText: "Items"
            },
            {
                id: "15.3K",
                detailsNumber: "5.3K",
                detailsText: "Owners"
            },
            {
                id: "22.55",
                detailsNumber: "2.55",
                detailsText: "Floor Price"
            },
            {
                id: "317.2K",
                detailsNumber: "17.2K",
                detailsText: "Volume Traded"
            }, 
        ],
        amount: "1,589.03"
    },
    {
        id: "avatar_13",
        title: "Arcahorizons",
        image: "/images/avatars/avatar_13.jpg",
        icon: true,
        creator: "Crytopank",
        text: "Unique, fully 3D and built to unite the design multiverse. Designed and styled by Digimental.",
        details: [
            {
                id: "07.2K",
                detailsNumber: "7.2K",
                detailsText: "Items"
            },
            {
                id: "15.3K",
                detailsNumber: "5.3K",
                detailsText: "Owners"
            },
            {
                id: "22.55",
                detailsNumber: "2.55",
                detailsText: "Floor Price"
            },
            {
                id: "317.2K",
                detailsNumber: "17.2K",
                detailsText: "Volume Traded"
            }, 
        ],
        amount: "1,157"
    },
    {
        id: "avatar_14",
        title: "Sussygirl",
        image: "/images/avatars/avatar_14.jpg",
        icon: false,
        creator: "Hey Mrsmeseks",
        text: "Unique, fully 3D and built to unite the design multiverse. Designed and styled by Digimental.",
        details: [
            {
                id: "07.2K",
                detailsNumber: "7.2K",
                detailsText: "Items"
            },
            {
                id: "15.3K",
                detailsNumber: "5.3K",
                detailsText: "Owners"
            },
            {
                id: "22.55",
                detailsNumber: "2.55",
                detailsText: "Floor Price"
            },
            {
                id: "317.2K",
                detailsNumber: "17.2K",
                detailsText: "Volume Traded"
            }, 
        ],
        amount: "1,030"
    },
    {
        id: "avatar_15",
        title: "Smilebin",
        image: "/images/avatars/avatar_15.jpg",
        icon: true,
        creator: "alyxbow",
        text: "Unique, fully 3D and built to unite the design multiverse. Designed and styled by Digimental.",
        details: [
            {
                id: "07.2K",
                detailsNumber: "7.2K",
                detailsText: "Items"
            },
            {
                id: "15.3K",
                detailsNumber: "5.3K",
                detailsText: "Owners"
            },
            {
                id: "22.55",
                detailsNumber: "2.55",
                detailsText: "Floor Price"
            },
            {
                id: "317.2K",
                detailsNumber: "17.2K",
                detailsText: "Volume Traded"
            }, 
        ],
        amount: "999.51"
    },
    {
        id: "avatar_16",
        title: "Pankysmoke",
        image: "/images/avatars/avatar_16.jpg",
        icon: false,
        creator: "Wow Frens",
        text: "Unique, fully 3D and built to unite the design multiverse. Designed and styled by Digimental.",
        details: [
            {
                id: "07.2K",
                detailsNumber: "7.2K",
                detailsText: "Items"
            },
            {
                id: "15.3K",
                detailsNumber: "5.3K",
                detailsText: "Owners"
            },
            {
                id: "22.55",
                detailsNumber: "2.55",
                detailsText: "Floor Price"
            },
            {
                id: "317.2K",
                detailsNumber: "17.2K",
                detailsText: "Volume Traded"
            }, 
        ],
        amount: "875.65"
    }, 
];
var collection_activity_item_data = [
    {
        id: "0Lazyone Panda",
        image: "/images/avatars/avatar_2.jpg",
        title: "Lazyone Panda",
        price: "sold for 1.515 ETH",
        time: "30 minutes 45 seconds ago",
        category: "purchases"
    },
    {
        id: "1NFT Funny Cat",
        image: "/images/avatars/avatar_1.jpg",
        // image: '/images/products/item_21_sm.jpg',
        title: "NFT Funny Cat",
        price: "listed by 051_Hart .08095 ETH",
        time: "40 minutes 36 seconds ago",
        category: "listing"
    },
    {
        id: "2Prince Ape Planet",
        image: "/images/avatars/avatar_3.jpg",
        // image: '/images/products/item_22_sm.jpg',
        title: "Prince Ape Planet",
        price: "tranferred from 027ab52",
        time: "1 hour 15 minutes ago",
        category: "transfer"
    },
    {
        id: "3Origin Morish",
        image: "/images/avatars/avatar_4.jpg",
        // image: '/images/products/item_23_sm.jpg',
        title: "Origin Morish",
        price: "bid cancelled by 0397fd",
        time: "1 hour 55 minutes ago",
        category: "bids"
    },
    {
        id: "4Portrait Gallery#029",
        image: "/images/avatars/avatar_5.jpg",
        // image: '/images/products/item_24_sm.jpg',
        title: "Portrait Gallery#029",
        price: "liked by Trina_more",
        time: "2 hours 24 minutes ago",
        category: "likes"
    },
    {
        id: "5Portrait Gallery#029",
        image: "/images/avatars/avatar_6.jpg",
        // image: '/images/products/item_24_sm.jpg',
        title: "Portrait Gallery#029",
        price: "liked by Trina_more",
        time: "2 hours 24 minutes ago",
        category: "likes"
    },
    // =============
    // =============
    // =============
    {
        id: "6Lazyone Panda",
        image: "/images/avatars/avatar_3.jpg",
        title: "Lazyone Panda",
        price: "sold for 1.515 ETH",
        time: "30 minutes 45 seconds ago",
        category: "purchases"
    },
    {
        id: "7NFT Funny Cat",
        image: "/images/avatars/avatar_2.jpg",
        // image: '/images/products/item_21_sm.jpg',
        title: "NFT Funny Cat",
        price: "listed by 051_Hart .08095 ETH",
        time: "40 minutes 36 seconds ago",
        category: "listing"
    },
    {
        id: "8Prince Ape Planet",
        image: "/images/avatars/avatar_5.jpg",
        // image: '/images/products/item_22_sm.jpg',
        title: "Prince Ape Planet",
        price: "tranferred from 027ab52",
        time: "1 hour 15 minutes ago",
        category: "transfer"
    },
    {
        id: "9Origin Morish",
        image: "/images/avatars/avatar_6.jpg",
        // image: '/images/products/item_23_sm.jpg',
        title: "Origin Morish",
        price: "bid cancelled by 0397fd",
        time: "1 hour 55 minutes ago",
        category: "bids"
    },
    {
        id: "10Portrait Gallery#029",
        image: "/images/avatars/avatar_3.jpg",
        // image: '/images/products/item_24_sm.jpg',
        title: "Portrait Gallery#029",
        price: "liked by Trina_more",
        time: "2 hours 24 minutes ago",
        category: "likes"
    },
    {
        id: "11Portrait Gallery#029",
        image: "/images/avatars/avatar_1.jpg",
        // image: '/images/products/item_24_sm.jpg',
        title: "Portrait Gallery#029",
        price: "liked by Trina_more",
        time: "2 hours 24 minutes ago",
        category: "bids"
    }, 
];
var collectionCategoryData = [
    {
        parentId: 1,
        name: " Today's Drops",
        collections: [
            {
                id: 1,
                title: "NFT Funny Cat",
                image: "/images/avatars/avatar_1.jpg",
                icon: true,
                amount: "7,080.95",
                postTime: "2022-07-20"
            },
            {
                id: 2,
                title: "Cryptopank",
                image: "/images/avatars/avatar_2.jpg",
                icon: true,
                amount: "6,548,133",
                postTime: "2022-07-10"
            },
            {
                id: 3,
                title: "Prince Ape Planet",
                image: "/images/avatars/avatar_3.jpg",
                icon: false,
                amount: "4,823,927",
                postTime: "2022-07-08"
            },
            {
                id: 4,
                title: "Hey Mrsmeseks",
                image: "/images/avatars/avatar_4.jpg",
                icon: true,
                amount: "3,186",
                postTime: "2022-07-01"
            }, 
        ]
    },
    {
        parentId: 2,
        name: "Top Sellers",
        collections: [
            {
                id: 5,
                title: "Bored Bunny",
                image: "/images/avatars/avatar_5.jpg",
                icon: false,
                amount: "3,027",
                postTime: "2022-07-05"
            },
            {
                id: 6,
                title: "Wow Frens",
                image: "/images/avatars/avatar_6.jpg",
                icon: false,
                amount: "2,586",
                postTime: "2022-07-08"
            },
            {
                id: 7,
                title: "Origin Morish",
                image: "/images/avatars/avatar_7.jpg",
                icon: true,
                amount: "2,347.85",
                postTime: "2022-07-20"
            },
            {
                id: 8,
                title: "Superdo",
                image: "/images/avatars/avatar_8.jpg",
                icon: true,
                amount: "2,115.71",
                postTime: "2022-07-10"
            }, 
        ]
    },
    {
        parentId: 3,
        name: "Top Buyers",
        collections: [
            {
                id: 9,
                title: "NFT stars",
                image: "/images/avatars/avatar_9.jpg",
                icon: false,
                amount: "2,027",
                postTime: "2022-07-12"
            },
            {
                id: 10,
                title: "Asumitsu",
                image: "/images/avatars/avatar_10.jpg",
                icon: true,
                amount: "1,989.70",
                postTime: "2022-07-15"
            },
            {
                id: 11,
                title: "Pank Skull",
                image: "/images/avatars/avatar_11.jpg",
                icon: false,
                amount: "1,726.70",
                postTime: "2022-07-16"
            },
            {
                id: 12,
                title: "Lazy Panda",
                image: "/images/avatars/avatar_12.jpg",
                icon: false,
                amount: "1,589.03",
                postTime: "2022-07-14"
            }, 
        ]
    }, 
];



/***/ }),

/***/ 9317:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony exports items_offer_data, items_Properties_data, items_activity_data */
var items_offer_data = [
    {
        id: "1ViviGiallo",
        ethPrice: "30",
        usdPrice: "$90,136.10",
        difference: "70%",
        Expiration: "5",
        user: "ViviGiallo"
    },
    {
        id: "2DB96DB",
        ethPrice: "15.5",
        usdPrice: "$45,458.10",
        difference: "70%",
        Expiration: "5",
        user: "DB96DB"
    },
    {
        id: "3myc_nc",
        ethPrice: "0.9",
        usdPrice: "$2,347.90",
        difference: "98%",
        Expiration: "5",
        user: "myc_nc"
    },
    {
        id: "4MetaRDnA",
        ethPrice: "1.2",
        usdPrice: "$4,568.40",
        difference: "100%",
        Expiration: "6",
        user: "MetaRDnA"
    },
    {
        id: "5Karafuru",
        ethPrice: "0.5",
        usdPrice: "$1,699.10",
        difference: "100%",
        Expiration: "6",
        user: "Karafuru"
    },
    {
        id: "6seekortelur",
        ethPrice: "4.7",
        usdPrice: "$13,966.64",
        difference: "40%",
        Expiration: "2",
        user: "seekortelur"
    }, 
];
var items_Properties_data = [
    {
        id: 0,
        category: "ACCESSORY",
        product: "Metal headband",
        trait: "3% have this trait"
    },
    {
        id: 1,
        category: "SKIN",
        product: "Dark Brown",
        trait: "8% have this trait"
    },
    {
        id: 2,
        category: "EYES",
        product: "Cyborg",
        trait: "2% have this trait"
    },
    {
        id: 3,
        category: "CLOTH",
        product: "Adidas",
        trait: "7% have this trait"
    },
    {
        id: 4,
        category: "HAIR",
        product: "White Ash",
        trait: "7% have this trait"
    },
    {
        id: 5,
        category: "CHARACTER",
        product: "TSAREVNA",
        trait: "1% have this trait"
    },
    {
        id: 6,
        category: "BACKGROUND",
        product: "CyberPunk",
        trait: "9% have this trait"
    },
    {
        id: 7,
        category: "MOUTH",
        product: "Flower",
        trait: "4% have this trait"
    }, 
];
var items_activity_data = [
    {
        id: "1ViviGiallo",
        price: "30",
        from: "AD496A",
        to: "Polymorph: MORPH Token",
        date: "19 days ago",
        text: "bid"
    },
    {
        id: "2DB96DB",
        price: ".00510",
        from: "The_vikk",
        to: "Polymorph: MORPH Token",
        date: "16 days ago",
        text: "transfer"
    },
    {
        id: "3myc_nc",
        price: "1.50",
        from: "CryptoGuysNFT",
        to: "Polymorph: MORPH Token",
        date: "19 days ago",
        text: "sale"
    }, 
];



/***/ })

}]);